import { FC } from 'react';
import { Kalenderhändelse } from '../../types/pages';
import styles from './KalenderHändelseContent.module.css';
import { BodyText } from '@kpa/kul';
import KalenderHändelseTag from './KalenderHändelseTag';

type KalenderHändelseContentProps = {
  händelse: Kalenderhändelse;
};

const KalenderHändelseContent: FC<KalenderHändelseContentProps> = ({ händelse }) => {
  return (
    <div className={styles.container}>
      <BodyText className={styles.title} color={händelse.notis ? undefined : 'darkBlue'}>
        {händelse.rubrik}
      </BodyText>
      <BodyText className={styles.subtitle}>
        {händelse.teasertext}
      </BodyText>
      <KalenderHändelseTag händelse={händelse}></KalenderHändelseTag>
    </div>
  );
};

export default KalenderHändelseContent;
